import { useMemo } from 'react';
import { formatMoney } from '../model/engine';
import { computeSensitivityTable } from '../model/sensitivity';

function formatDelta(n) {
  if (n == null || !Number.isFinite(n)) return '—';
  const sign = n > 0 ? '+' : '';
  return `${sign}${formatMoney(n)}`;
}

export default function SensitivityPanel({ scenario }) {
  const rows = useMemo(() => computeSensitivityTable(scenario), [scenario]);

  return (
    <section className="chart-card">
      <h2>Sensitivity (±20%)</h2>
      <p className="chart-hint">
        Horizon variable COGS and net gross margin (revenue − Plaid − Stripe − AI) at end of
        projection. One-time Auth is excluded from gross margin. Deterministic path from current
        scenario — does not change saved assumptions.
      </p>
      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              <th>Lever</th>
              <th>−20%</th>
              <th>Base</th>
              <th>+20%</th>
              <th>Δ COGS (+20%)</th>
              <th>Δ net GM (+20%)</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td>{row.label}</td>
                <td>
                  {formatMoney(row.low.horizonCogs)}
                  <span className="economics-muted"> · GM {formatMoney(row.low.netGm)}</span>
                </td>
                <td>
                  {formatMoney(row.base.horizonCogs)}
                  <span className="economics-muted"> · GM {formatMoney(row.base.netGm)}</span>
                </td>
                <td>
                  {formatMoney(row.high.horizonCogs)}
                  <span className="economics-muted"> · GM {formatMoney(row.high.netGm)}</span>
                </td>
                <td>{formatDelta(row.high.deltaCogs)}</td>
                <td>{formatDelta(row.high.deltaNetGm)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
